import React from 'react'

import { RadioMenu, SurfaceContainer } from '@caudena/core/ui-kit'
import { InputDropdown } from '@caudena/core/ui-kit'

import { FieldProps } from './types'

const options = [
  {
    label: 'In',
    value: 'in' as const,
  },
  {
    label: 'Out',
    value: 'out' as const,
  },
  {
    label: 'Both (In/ Out)',
    value: 'both' as const,
  },
]

const TransactionDirection = ({ value, onChange }: FieldProps<string>) => {
  const handleInputClear = () => {
    onChange('')
  }

  const handleChange = (selected) => {
    onChange(selected)
  }

  const printValue = options.find(({ value: v }) => v === value)?.label || ''

  return (
    <InputDropdown
      clearable
      sameWidth
      padded={false}
      variant="outline"
      startAddon={{ label: 'Transaction direction:' }}
      placeholder="Any"
      value={printValue}
      onClear={handleInputClear}
    >
      <SurfaceContainer spaces={'md'}>
        <RadioMenu
          options={options}
          value={value ?? undefined}
          onChange={handleChange}
        />
      </SurfaceContainer>
    </InputDropdown>
  )
}

export default TransactionDirection
